import { Component, Vue } from 'vue-property-decorator';
import WithRender from './bulkupload.html';
import config from '@/settings/config.js';
import _axios from '@/services/axios';
import { IUserInfo } from '@/Models/IUserInfo';
import Loading from 'vue-loading-overlay';
import { mapGetters } from 'vuex';
import { PriceList, ProductRow } from '@/types/ProductTypes';

@WithRender
@Component({
  components: {
    Loading,
  },
  computed: {
    ...mapGetters("originatorStore", { originator: "getOriginator", currency: "getWalletCurrency" }),
  }
})
export default class BulkUpload extends Vue {
  priceList: PriceList = {} as PriceList;
  productSelected = 'airtime';
  originator!: string;
  currency!: string;
  userInfo: IUserInfo = {} as IUserInfo;
  isLoading = false;
  file1: File | null = null;
  selectedFile = {} as File;
  options = [
    { value: "mw", text: "Malawi" },
    { value: "zw", text: "Zimbabwe" },
    { value: "za", text: "South Africa" }
  ]

  providerOptions = [
    { value: "tnmdata", text: "TNM Data" }
  ]
  dataOptions = []
  selectedProduct = {} as ProductRow;
  form = {
    isoCountry: '',
    selectedPortifolio: '',
    description: '',
  }

  onFileChanged(event: any) {
    this.selectedFile = event.target.files[0];
  }

  Notify(message: any) {
    this.$bvToast.toast(message, {
      title: "Notification",
      variant: "danger",
      autoHideDelay: 5000,
    });
  }

  validate() {
    if (this.form.description == null) {
      this.Notify("Please enter a brief description");
      return false;
    }
    return true;
  }

  isDataSelected() {
    if (this.productSelected == 'data') {
      return true;
    }
    return false;
  }

  public getPriceList() {
    this.isLoading = true;
    let dto =
    {
      portiFolio: this.form.selectedPortifolio,
      originator: this.originator,
      parameters: null
    }
    this.$store.dispatch("product/GetPortiFolioOnlyProducts", dto)
      .then(value => {
        this.priceList = value as PriceList;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }

  onUpload() {
    if (!this.validate()) return;
    const formData = new FormData();
    this.isLoading = true;
    const fileToUpload = this.file1 as File;
    formData.append("file", fileToUpload, fileToUpload.name);
    formData.append("description", this.form.description);
    formData.append("isoCountry", this.form.isoCountry);
    formData.append("originator", this.originator);
    formData.append("currency", this.currency);

    if (this.productSelected == 'data') {
      formData.append("portFolio", this.form.selectedPortifolio);
      formData.append("amount", this.selectedProduct.salesCurrencyAmount as unknown as string);
      formData.append("extra1", this.selectedProduct.extra1);
    }

    _axios
      .post(config.gateway + "bulk/bulkupload/Upload", formData, {
        onUploadProgress: (progressEvent) => {
          console.log(progressEvent.loaded / progressEvent.total);
        },
      })
      .then((response) => {
        this.$router.push("callback?msg=" + response.data);
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.status &&
          err.response.status == "400"
        ) {
          this.Notify(err.response.data.error);
        }
        else
          this.Notify("please check that you have data or your internet connection is on");
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
